import React from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Profile",
        page_path: "/app/profile",
        icon: "user",
    }
]
const ProfileDetails = ({data, onEdit}) => {

        return (
            <>
            <Breadcumb items={BreadcrumbData} />
            <div className="page-wrapper">
            <Container>
<Card className="card">
    <CardContent>
          <Grid container spacing={3}>                                       
           <Grid item lg={6} sm={6}>
           <Typography variant="h5" gutterBottom>
        Profile
       </Typography>
           Name : { data.name} <br/>
           Email : { data.email} <br/>
          {data.gender !== '' &&  `Gender : ${data.gender}` } <br/>
          {data.dob !== '' &&  `DOB : ${data.dob}` } <br/>
          {data.mobile_number !== '' &&  `Mobile Number : ${data.mobile_number}` } <br/>
          {data.city !== '' &&  `City : ${data.city}` } <br/>
          {data.state !== '' &&  `State : ${data.state}` }  <br/>
          {data.country !== '' &&  `Country : ${data.country}` } <br/>
          {/* {data.is_active !== '' &&  `isAcive : ${data.is_active}` } <br/> */}
           </Grid>
           <Grid item lg={6} sm={6}>
           <Typography variant="h5" gutterBottom>
        Roles
       </Typography>
            {
                data.roles.map(item =>{
                    return <p>{item}</p>
                })
            }

           </Grid>
   
        </Grid>
        
    </CardContent>
    <CardActions>
    <Button variant="contained" color="primary" onClick={onEdit}>Edit</Button>
    </CardActions>
</Card>
</Container>
            </div>
        </>
        )
}

export default ProfileDetails;
